import SiteContentEditor from "@/project/jain_elibrary-admin/pages/content/SiteContentEditor";

const AboutUs = () => <SiteContentEditor slug="about" heading="About Us" />;

export default AboutUs;
